import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.806 0 25-11.194 25-25C50 11.193 38.805 0 25 0 11.193 0 0 11.193 0 25c0 13.806 11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M24.998 0c-8.178 0-15.44 3.928-20 10h40.001C40.44 3.928 33.177 0 25 0ZM24.998 50c8.18 0 15.44-3.928 20.001-10H4.998c4.56 6.072 11.822 10 20 10ZM0 25c0 1.712.173 3.384.5 5H49.5c.328-1.616.5-3.288.5-5 0-1.712-.173-3.384-.5-5H.5A25.107 25.107 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M7.323 7.321c-9.763 9.763-9.763 25.592 0 35.355l17.678-17.678L7.323 7.321Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m10.119 18.478 1.619 4.982h5.238l-4.238 3.08 1.619 4.982-4.238-3.08-4.238 3.08L7.5 26.54l-4.238-3.08H8.5l1.619-4.982Z"
}));
FlagPR.displayName = 'FlagPR';
export default withFlagWrapper(FlagPR);
//# sourceMappingURL=index.js.map